import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';
import {
  addStage,
  deleteStage,
  editStage,
  loadStage,
} from '../actions/boardStage';
import { fetchAllData } from '../api/boardSettings';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';

export function createStage(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/boardStage`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(addStage({ stage: json }));
            dispatch(fetchAllData());
            dispatch(push('/pages/boardsettings'));
            dispatch(notify({
              title: 'Add New Stage',
              message: 'Stage added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Add New Stage',
            message: 'Failed to add new stage',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function removeStage(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/boardStage/deleteStage/${data.id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(deleteStage({ id: data.id }));
            dispatch(fetchAllData());
            dispatch(notify({
              title: 'Delete Stage',
              message: 'Stage deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Delete Stage',
            message: 'Failed to delete stage',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function refreshStage(id, data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/boardStage/${id}`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(editStage({ stage: json }));
            dispatch(fetchAllData());
            dispatch(push('/pages/boardsettings'));
            dispatch(notify({
              title: 'Edit Stage',
              message: 'Stage added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Edit Stage',
            message: 'Failed to edit stage',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function fetchStageById(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/boardStage/getDetails/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadStage({ stage: json }));
          }
        })
    }
  }
}


// WEBPACK FOOTER //
// ./src/api/boardStage.js